import React, { useEffect, useState } from 'react';
import './select.less';
import { Input as AntdInput, Select as AntdSelect } from 'antd';
import classNames from 'classnames';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
const { Option } = AntdSelect;

const Select = (props) => {
  const [selectFocused, setSelectFocused] = useState(false);
  const [selectItem, setSelectItem] = useState('');

  useEffect(() => {
    if (props.value || props.defaultValue) {
      setSelectFocused(true);
    } else {
      setSelectFocused(false);
    }
  }, [props.value]);

  function onChange(e) {
    setSelectItem(e);
    props.onChange(e);
  }

  return (
    <div
      className={classNames(
        'select',
        props.compClass,
        { focus: selectFocused },
        { 'select--parameters': props.parameters }
      )}
    >
      {props.label ? <label>{props.label}</label> : false}
      <AntdSelect
        {...props}
        onChange={(e) => {
          onChange(e);
        }}
        suffixIcon={<DownChevronIcon />}
      >
        {props.data.map((item, index) => {
          return (
            <Option
              key={props.keyvalue ? item[props.keyvalue] : item + index}
              value={props.keyvalue ? item[props.keyvalue] : item}
            >
              {props.labelvalue ? item[props.labelvalue] : item}
            </Option>
          );
        })}
      </AntdSelect>
      {props.info ? <span className="select__info">{props.info}</span> : false}
    </div>
  );
};

export default Select;
